import createLucideIcon from '../createLucideIcon';

const Bold = createLucideIcon('Bold', [
  ['path', { d: 'M14 12a4 4 0 0 0 0-8H6v8', key: 'v2sylx' }],
  ['path', { d: 'M15 20a4 4 0 0 0 0-8H6v8Z', key: '1ef5ya' }],
]);

export default Bold;
